<template>
    <div id="coll">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;padding-left: 20px">
                <div style="margin: auto 0;color: #595a5a"><span >当前位置：</span></div>
                <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                    <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                        {{item}}
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>

        </div>
        <div class="form-body">
            <el-form :ref="form" :model="form" label-width="80px" style="padding: 0 5px">
                <el-form-item label="店铺名称">
                    <el-tag v-on:click="show">全部</el-tag>
                    <el-tag style="margin-left: 10px;" @click="show" :key="index" v-for="(item,index) in dpList">{{item}}</el-tag>
                </el-form-item>
                <div style="border-top: 2px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型">
                        <el-radio-group v-model="form.searchType" size="small">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">产品ID</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容">
                        <el-input size="small" v-model="form.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="padding-bottom: 10px;display: inline-block;width: 100%">

        </div>
        <div>
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                      :span-method="arraySpanMethod">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="img" label="图片" width="95" align="center">
                    <template scope="scope">
                        <div>
                            <div class="imgInDiv">
                                <div class="borderDiv">
                                    <img class="imgCls" :src="scope.row.img"/>
                                    <div class="pz_o">
                                        <div class="pz_po">
                                            <div class="pz_at">
                                                <a>添加来源</a>
                                            </div>
                                            <div class="pz_img_o" style="width: 300px;height: 300px;">
                                                <img class="outImg" :src="scope.row.img">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ly">
                                <a>1688</a>
                            </div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题/产品ID" width="120">
                </el-table-column>
                <el-table-column prop="sppr"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.sppr"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="time" label="时间" align="center"></el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="addNote">添加备注</el-button><br/>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <el-pagination background style="float: right;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
                           :total="400">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CollectionBox",
        data() {
            return {
                currentPage: 1,
                form: {
                    searchStr: null,
                    searchType: 1
                },
                dpList: ["店铺1", "店铺2", "店铺3", "店铺4", "店铺5", "店铺6", "店铺7", ],
                tableData: [{
                    img: 'https://wxalbum-10001658.image.myqcloud.com/wxalbum/283967/20200714150201/dd9a1e6e4d2aeeca581cccf8f74a7fc0.jpg',
                    title: 'flower',
                    sppr: '<img src="../../assets/0.png" />',
                    time: '2020-09-01',
                    id: 1
                }],
                spanArr: [],
                innerTableData:[],
                innerData: [
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'},
                    {'sku':'sdasfasfasf','price':'100.10','price_1':'99.00','rep':'55'}
                ],

            }
        },
        created() {
            var tabHtml ='<table class="innerTab" style="width: 100%">'
            this.innerData.forEach((item,index)=>{
                if(index < 5){
                    tabHtml += `<tr>
					<td >`+item.sku +`</td>
					<td >`+item.price +`</td>
					<td >`+item.price_1 +`</td>
					<td >`+item.rep +`</td>
				</tr>`;
                }else{
                    tabHtml += `<tr style="display: none" class="hid_row">
					<td >`+item.sku +`</td>
					<td >`+item.price +`</td>
					<td >`+item.price_1 +`</td>
					<td >`+item.rep +`</td>
				</tr>`;
                }

            });
            if(this.innerData.length > 5){
                tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow()">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
            }else{
                tabHtml += `</table>`;
            }

            this.tableData[0].sppr = tabHtml;
            window.explanRow = function () {
                var flag = $(".hid_row").is(":hidden");
                if(flag){
                    $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                    $(".hid_row").show();
                }else{
                    $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                    $(".hid_row").hide();
                }
            }
        },
        methods: {
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            search: function() {
                this.form.searchStr = "45649";
                alert("查询");
            },
            batchHandle: function(val) {
                if ("1" == val) {
                    this.batchDelete();
                } else {
                    this.batchMove();
                }
            },
            batchDelete: function() {
                this.$confirm('确定要删除选中的商品吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            batchMove: function() {
                this.$confirm('确定要将选中的商品移入待发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleSelectionChange: function(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.$message({
                    message: '选择提示:已选择' + ids.length + '条',
                    center: true,
                    offset: 200
                });

            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            move: function() {
                this.$confirm('确定要 [取消定时吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消移入'
                    });
                });
            },
            edit: function(row) {
                //直接跳转
                this.$router.replace('/shopeeEdit')
            },
            addNote: function() {

            },
            deleteRow: function() {

            },
            handleNodeClick() {

            },

        },
        mounted() {
            this.getSpanArr(this.tableData);
            // jQuery(".tab_butt").click(function () {
            //     alert(123456);
            // });
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/Releasing.css';


</style>
